import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FilieraComponent } from './filiera/filiera.component';
import { HomeComponent } from './home/home.component';
import { AggiudicatariComponent } from './aggiudicatari/aggiudicatari.component';
import { ScadenzarioComponent } from './scadenzario/scadenzario.component';
import { AccessiComponent } from './accessi/accessi.component';
import { VariazioneComponent } from './variazione/variazione.component';
import { AlertComponent } from './alert/alert.component';

const routes: Routes = [
  { path: 'home', component: HomeComponent },
  { path: 'variazione', component: VariazioneComponent },
  { path: 'filiera', component: FilieraComponent },
  { path: 'aggiudicatari', component: AggiudicatariComponent },
  { path: 'scadenzario', component: ScadenzarioComponent },
  { path: 'accessi', component: AccessiComponent },
  { path: 'alert', component: AlertComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
